// This file is auto-generated. Do not edit manually.
import TemplateApp from '@templates/daily/App';

export function getTemplateComponent() {
  console.debug(`Template loaded: daily`);
  return TemplateApp;
}

export default TemplateApp;
